import { lazy } from 'react';
export const Products = lazy(() => import('@/Portal/Products/ProductTabs'));
export const CreateRetailProduct = lazy(() => import('@/Portal/Products/CreateRetailProduct'));
export const ViewRetailProduct = lazy(() => import('@/Portal/Products/ViewRetailProduct'));
